import React, { useEffect } from "react";
import { Switch, Route, useHistory, Redirect } from "react-router-dom";
import { useRouteMatch } from "react-router";

import BaseLayout from "../../components/layouts/BaseLayout";
import useSetState from "../../hooks/useSetState";

import VehicleGroups from "./VehicleGroups";
import VehicleModels from "./VehicleModels";
import VehicleIncidents from "./incidents/VehicleIncidents";
import VehicleTypes from "./VehicleTypes";
import VehicleTemplates from "./VehicleTemplates";
import { DEFAULT_ROUTE } from "../../components/navigation/Navigation";

const Fleet = () => {
  const history = useHistory();
  const match = useRouteMatch({
    path: "/admin/fleet/:activeTabURL",
    strict: true,
    sensitive: true,
  });
  const { activeTabURL } = match?.params as any;

  const tabs = [
    { label: "Vehicles", value: "vehicles" },
    { label: "Groups", value: "groups" },
    { label: "Models", value: "models" },
    { label: "Types", value: "types" },
    { label: "Templates", value: "templates" },
    { label: "Incidents", value: "incidents" },
  ];

  const [{ activeTab }, setState] = useSetState({ activeTab: "vehicles" });

  useEffect(() => {
    setState({ activeTab: activeTabURL });
  }, []);

  const handleTabClick = (event, newValue) => {
    history.push(`/admin/fleet/${newValue}`);
    setState({ activeTab: newValue });
  };
  // @ts-ignore
  return (
    <BaseLayout
      title="Fleet"
      tabs={tabs}
      handleTabChange={handleTabClick}
      activeTab={activeTab}
    >
      <Switch>
        {/* <Route path="/admin/fleet/vehicles" exact>
          <Vehicles />
        </Route> */}
        <Route path="/admin/fleet/groups" exact>
          <VehicleGroups />
        </Route>
        <Route path="/admin/fleet/models" exact>
          <VehicleModels />
        </Route>
        <Route path="/admin/fleet/types" exact>
          <VehicleTypes />
        </Route>
        <Route path="/admin/fleet/templates" exact>
          <VehicleTemplates />
        </Route>
        <Route path="/admin/fleet/incidents" exact>
          <VehicleIncidents />
        </Route>
        <Redirect to={DEFAULT_ROUTE} />
      </Switch>
    </BaseLayout>
  );
};

export default Fleet;
